import React from "react";

const GroupByChips = ({ groupBy, onChange }) => (
  <div className="d-flex align-items-center gap-2 flex-wrap mb-3">
    <span className="small fw-bold text-muted">Gruplama:</span>
    {[
      ["day", "Günlük"],
      ["week", "Haftalık"],
      ["month", "Aylık"],
    ].map(([g, lbl]) => (
      <button
        key={g}
        type="button"
        className={`rp-chip ${groupBy === g ? "active" : ""}`}
        onClick={() => onChange(g)}
      >
        {lbl}
      </button>
    ))}
  </div>
);

export default GroupByChips;
